module.exports = __webpack_public_path__ + "static/media/Landscape.98b102ee.jpg";